import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { pricingResponse, type UsePricing } from './Pricing.schema';

export const pricingKeys = { all: ['pricing'] as const };

export const usePricing = (opts: UsePricing['opts'] = {}) =>
	useQuery<UsePricing['response']>({
		...opts,
		queryKey: pricingKeys.all,
		queryFn: () => API.get('/pricing').then((res) => pricingResponse.parse(res.data)),
		// Prices change with a deploy, not while the page is open.
		staleTime: Infinity,
	});
